<template>
  <page-with-back-btn title="Select Customer" :back="backButton">
    <div class="search-box shadow-sm d-flex py-1 px-3">
      <form @submit.prevent="getAllDebtors">
        <div class="row">
          <div class="col-md-3 d-flex flex-row">
            <div class="form-floating mx-1" style="width: 80%">
              <input type="text" class="form-control"
                     v-model="form.Name" id="customerName"
                     placeholder="Customer Name">
              <label for="customerName">Customer Name</label>
            </div>
            <button class="lyt-soft-btn h-100" style="width: 15%;" type="button" @click="createDebtor">
              <font-awesome-icon icon="fa-solid fa-plus"/>
            </button>
          </div>

          <div class="col-md-3">
            <div class="form-floating ">
              <input type="text" class="form-control"
                     v-model="form.tpin" id="customerTPIN"
                     placeholder="TPIN">
              <label for="customerTPIN">TPIN</label>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating ">
              <input type="text" class="form-control"
                     v-model="form.contact" id="customerContact"
                     placeholder="Contact No.">
              <label for="customerContact">Contact No.</label>
            </div>
          </div>

          <div class="col-md-3 d-flex align-items-center justify-content-end">
            <div class="form-check me-3">
              <input class="form-check-input" type="checkbox" id="isCash" v-model="form.isCash">
              <label class="form-check-label" for="isCash">
                Is Cash
              </label>
            </div>
            <button class="lyt-soft-btn" type="submit">Search</button>
          </div>
        </div>
      </form>
    </div>

    <div class="text-center d-flex justify-content-between align-items-center px-3 m-2">
      <span>Sale Total :</span>
      <h3 class="fw-bold m-0">{{ $utils.formatMoney(saleTotal) }}</h3>
    </div>

    <div class="d-none d-md-block">
      <div class="table-responsive list-body h-100 w-100">
        <table class="table table-hover align-middle debtor-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Contact</th>
              <th>TPIN</th>
              <th class="text-end">Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="debtor in debtors" :key="debtor.Id" class="debtor-row" @click="chooseAction(debtor)">
              <td>{{ debtor.Name }} {{ debtor.Surname }}</td>
              <td>{{ debtor.CellNumber }}</td>
              <td>{{ debtor.vat }}</td>
              <td class="text-end fw-bold">{{ $utils.formatMoney(debtor.Balance) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="d-md-none">
      <DynamicScroller
          :items="debtors"
          key-field="Id"
          :min-item-size="141"
          class="list-body h-100 w-100">
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
              :item="item"
              :active="active"
              :data-index="index">
            <DebtorListItem :debtor="item" @click="chooseAction(item)"/>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
    </div>

  </page-with-back-btn>
</template>

<script>
import DebtorListItem from "@/components/point-of-sale/Accounts/DebtorListItem";
import PageWithBackBtn from "@/components/layout/utils/PageWithBackBtn";

export default {
  name: "SelectCustomer",
  components: {PageWithBackBtn, DebtorListItem},
  beforeMount() {
    this.getAllDebtors();
  },
  computed: {
    debtors() {
      return this.$store.getters.getDebtors
    },
    saleDetails() {
      return this.$store.getters.getSaleDetails
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal
    },
    isASale() {
      return this.$store.getters.getSaleUnits;
    },
  },
  data() {
    return {
      loading: true,
      form: {
        Name: "",
        tpin: "",
        contact: "",
        isCash: false
      },
      saleNumber : this.$route.query.saleNumber
    }
  },
  methods: {
    getAllDebtors() {
      this.$utils.showLoading()
      return this.$store.dispatch('getAllDebtors', this.form)
          .finally(() => this.$utils.hideLoading());
    },

    chooseAction(debtor) {
      this.$store.commit(`setCustomer`, debtor.Id);
      if (this.isASale) {
        return this.saleActions(debtor);
      }
      return this.nonSaleActions(debtor);
    },

    nonSaleActions(debtor) {
      return Swal.fire({
        title: `Choose Action`,
        html: `<h6>Debtor : ${debtor.Name} ${debtor.Surname}</h6><br>
                 Balance : ${this.$utils.formatMoney(debtor.Balance)} `,
        showCancelButton: false,
        showDenyButton : false,
        confirmButtonText: 'Make Payment',
        showCloseButton: true,
        denyButtonText: `PrintStatement`,
        denyButtonColor: `rgb(88, 125, 224)`,
      }).then((result) => {
        if (result.isConfirmed) {
          return this.makeAccountPayment(debtor.Id);
        } else if (result.isDenied) {
          return this.printDebtorStatement(debtor.Id);
        }
      })
    },

    backButton(){
      return this.$router.push({
        name: 'pos' ,
        query : {
          saleNumber : this.saleNumber,
          dontReload: true,
        }
      });
    },

    saleActions(debtor) {
      return Swal.fire({
        title: `Choose Action <br><h6>Debtor : ${debtor.Name} ${debtor.Surname}</h6>`,
        showDenyButton: true,
        showCloseButton : true,
        showCancelButton: true,
        confirmButtonText: 'Quote',
        denyButtonText: `Add to Sale`,
        cancelButtonText: `Sell On Account`,
        denyButtonColor: `rgb(88, 125, 224)`,
        cancelButtonColor: `rgb(88, 125, 224)`,
      }).then((result) => {
        if (result.isConfirmed) {
          return this.quoteCustomer(debtor);
        } else if (result.isDenied) {
          this.$store.commit(`setCustomer`, debtor.Id);
          responses.showSuccess(`Customer ${debtor.Name} added Successfully`)
          return this.backButton();
        } else if (result.isDismissed && result.dismiss === `cancel`) {
          return this.processTransaction('AccountSale');
        }
      })
    },

    processTransaction(type) {
      this.$store.commit('setSaleDetails', {
        refund: false,
        reference: this.$store.getters.getOpenTableName,
        total: parseFloat(this.saleTotal.toFixed(2)),
        paid: parseFloat(this.saleTotal.toFixed(2)),
        change: 0
      });
      let obj = this.saleDetails;
      obj.type = type;
      return this.$store.dispatch("processTransaction", obj)
          .then((res) => {
            if (res) this.$router.push({name: 'viewPayment'})
          })
    },

    makeAccountPayment(customerID) {
      return Swal.fire({
        title: `Amount?`,
        icon: 'question',
        input: 'number',
        html: `<div class="form-floating mx-1">
            <select class="form-select" id="paymentOptions">
              <option value="Cash" selected>Cash</option>
              <option value="Card">Card</option>
              <option value="Kazang">Kazang</option>
            </select>
            <label for="paymentOptions">Payment Type</label>
          </div>`,
        showCancelButton: true,
        confirmButtonText: 'Make Payment',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          let paymentMethod = Swal.getPopup().querySelector('#paymentOptions').value;
          if (!input) return Swal.showValidationMessage(`Amount Paid is required`);
          let payload = {
            debId: customerID,
            PayedAmount: Number(input),
            Des: 'Account Till Payment',
            PaymentType: paymentMethod,
            datPay: this.$store.getters.currentTime.toString().replaceAll('T', ' ') + ':00',
          };
          if (paymentMethod === 'Kazang') {
            return this.kazangAccountPayment(payload)
          }
          return this.$store.dispatch('makeDebtorPayment', payload)
              .then(() => input).catch(error => Swal.showValidationMessage(error))
        },
      }).then((result) => this.$store.commit('setIsTabOpen', false))
    },

    kazangAccountPayment(payload) {
      return Swal.fire({
        title: 'Customer Phone No. ?',
        icon: 'question',
        input: 'tel',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Customer Phone No.`);
          payload.customerContact = input;
          return this.$store.dispatch('firstKazangAccountPaymentStep', payload)
              .then((res) => {
                if (res.Error) {
                  throw new Error(res.Error)
                } else {
                  res.paymentData = payload;
                  res.customerContact = input;
                  return res
                }
              }).catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return this.confirmKazangAccountPayment(result.value)
        }
      })
    },

    confirmKazangAccountPayment(firstKazangStepResponse) {
      if (firstKazangStepResponse === "processed") {
        return this.backButton()
      }
      return Swal.fire({
        title: 'Confirm Kazang Payment',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return this.$store.dispatch('secondKazangAccountPaymentStep', firstKazangStepResponse)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
              })
              .catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return this.backButton()
        }
      })
    },

    quoteCustomer(debtor) {
      this.$utils.showLoading()
      return this.$store.dispatch('saveNewTable', {
        name: this.$store.getters.getOpenTableName,
        Customer: debtor.Id,
      }).then((saveResult) => {
        // RESTAURANT-POS-Q: soft-skip — stay put while first save finishes
        if (saveResult && saveResult.skipped) {
          return;
        }
        return this.$router.push({ name : `tables` });
      })
          .finally(()=>this.$utils.hideLoading())
    },

    printDebtorStatement(customerID) {
      this.loading = true
      return this.$store.dispatch(`printDebtorStatement`, customerID)
          .finally(() => this.loading = false)
    },


    createDebtor() {
      return this.$router.push({
        name: "create-debtor" ,
        query : { saleNumber : this.saleNumber }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.search-box {
  position: sticky;
  background-color: var(--card-bg);
  top: 0;
  z-index: 1;
}

.col-md-4 {
  margin-bottom: 10px;

}

.form-floating input {
  background: var(--card-bg) !important;
  border: var(--card-border);
  color: var(--text-primary);
}

.form-floating input:focus {
  background: var(--card-bg);
  border-color: var(--accent-primary);
  color: var(--text-primary);
}

.form-floating label {
  color: var(--text-secondary);
}

.form-check-label {
  color: var(--text-primary);
}

// Table styles - override Bootstrap defaults
.table {
  background: var(--card-bg) !important;
  border: var(--card-border) !important;
  color: var(--text-primary) !important;
  margin-bottom: 0;

  > :not(caption) > * > * {
    background: var(--card-bg) !important;
    border-color: var(--card-border) !important;
  }

  thead {
    th {
      background: var(--secondary-button-bg) !important;
      color: var(--text-primary) !important;
      font-weight: 600;
      border-bottom: var(--card-border) !important;
      text-transform: uppercase;
      font-size: 0.85rem;
      letter-spacing: 0.5px;
    }
  }

  tbody {
    td {
      background: var(--card-bg) !important;
      color: var(--text-primary) !important;
      border-bottom: var(--card-border) !important;
      padding: 14px 16px;
    }

    tr {
      background: var(--card-bg) !important;
      transition: var(--transition-speed);

      &:hover {
        background: var(--secondary-button-bg) !important;
      }

      &:not(:last-child) td {
        border-bottom: var(--card-border) !important;
      }
    }
  }
}

.debtor-table {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  overflow: hidden;
  border-radius: 8px;
}

.debtor-row {
  cursor: pointer;

  &:hover {
    background: var(--secondary-button-bg) !important;
  }
}

// Ensure Bootstrap table-dark doesn't conflict
.table-dark {
  --bs-table-bg: var(--card-bg) !important;
  --bs-table-color: var(--text-primary) !important;
  --bs-table-border-color: var(--card-border) !important;
}
</style>

<style>
// Global table dark mode styles (non-scoped)
.customer-page-wrapper {
  .table {
    background: var(--card-bg) !important;
    border-color: var(--card-border) !important;
    color: var(--text-primary) !important;

    thead th {
      background: var(--secondary-button-bg) !important;
      color: var(--text-primary) !important;
      border-color: var(--card-border) !important;
    }

    tbody td {
      background: var(--card-bg) !important;
      color: var(--text-primary) !important;
      border-color: var(--card-border) !important;
    }
  }
}
</style>
